<nb-card>
  <nb-card-body
    ><div class="scan-wrapper">
      <div fullWidth class="scan-title text-center">Scan please...</div>
      <div class="icon"></div>
    </div>
    <div class="enter-code-wrapper text-center" (click)="onEnterCodeClick()">
      OR CLICK HERE TO ENTER CODE
    </div></nb-card-body
  >
</nb-card>
